<template>

        <a-pagination
            show-size-changer
            v-model:current="model.page"
            :total="model.totle"
            :page-size-options="pageSizeOptions"
            @showSizeChange="onShowSizeChange"
            @change='pageChange'
            :show-total="(total, range) => `第${range[0]}条 - 第${range[1]}条  共 ${total} 条`"
        >
            <template slot="buildOptionText" slot-scope="props">
                <span>{{ props.value }}条/页</span>
            </template>
        </a-pagination>

</template>
<script>
import { inject } from 'vue'
export default {
    componentname: "pagination",
    props:{
        model:{
            type:Object,
            default:function(){
                return {}
            }
        },
    },
    setup(){
        const pageChange = inject('pageChange')
        const onShowSizeChange = inject('onShowSizeChange')

        return {
            pageSizeOptions : ['10','25','50','100'],
            pageChange,
            onShowSizeChange

        }
    }
}
</script>

